module.exports = __webpack_public_path__ + "img/zeno-2.4d948510.jpg";